export default "https://cdn-static.gokick.com/assets/e732fce3df71ad981aa0ee65436659b369042414/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";